import React from "react";

const TableRow = ({ children, bottomLine = true, className , ...restProps  }) => {
  return <tr className={`${bottomLine && "border-b-[1px]"} ${className}`} {...restProps} >{children}</tr>;
};

export default TableRow;
